// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"956235bb","956":"c47cffb4"}[chunkId] + ".chunk.js";
};